/*
  The payload has no "locked" marker yet. Until it does, the criteria Orbit adds from a Layer 2
  segment (`perx_internal_seg_*`) are the ones the builder shows locked.
*/
const SEGMENT_ATTRIBUTE_PREFIX = 'perx_internal_seg_';

const asArray = (value: unknown): unknown[] => (Array.isArray(value) ? value : []);

/** The custom-attribute keys in an audience prefill that the builder must not let the user edit. */
export const lockedSegmentAttributes = (prefill: Record<string, unknown> | null): string[] => {
  const filters = prefill?.filters as { custom_attributes?: unknown } | undefined;

  return asArray(filters?.custom_attributes)
    .flatMap(group => asArray((group as { criteria?: unknown })?.criteria))
    .map(criterion => (criterion as { attribute?: unknown })?.attribute)
    .filter(
      (attribute): attribute is string =>
        typeof attribute === 'string' && attribute.startsWith(SEGMENT_ATTRIBUTE_PREFIX)
    );
};
